<template>
    <v-container fluid>
        <v-card>
            <v-card-title class="pb-2">
                <span class="profile-title">Profile</span>
            </v-card-title>

            <v-container fluid>
                <v-row>
                    <v-col :cols="6" class="pl-0 pt-0">
                        <v-progress-circular v-if="isLoading" :size="40" :width="7" indeterminate color="tertiary" />
                        <v-form ref="editForm" v-if="!isLoading" :key="formKey">
                            <v-card>
                                <v-card-text>
                                    <v-text-field type="number" v-model="item.membershipNumber" label="Membership Number" readonly />
                                    <contact-fields v-model="item.contact" :remove-email-address="true" :contact-id="item.contactId" :rules="contactRules" />
                                    <v-select v-model="item.operations" :items="operations" label="Operation" :rules="operationRules" required multiple />
                                    <file-upload v-if="!operationsContainHoneyPacker" v-model="item.codeOfPracticeDeclarationFileId" label="Code of Practice Declaration" :disable-delete="true" />
                                </v-card-text>
                                <v-card-actions>
                                    <div class="flex-grow-1"></div>
                                    <v-btn color="quaternary" text @click="load">Cancel</v-btn>
                                    <v-btn color="quaternary" text @click="save">Save</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-form>
                    </v-col>
                </v-row>
                <template v-if="!operationsContainHoneyPacker">
                    <v-row class="pb-0 mb-0">
                        <v-col class="pb-0 mb-0">
                            <v-btn class="pb-0 mb-0" href="docs/code-of-practice-declaration.xlsx" target="_blank">Download Code of Practice Declaration</v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="pt-0 mt-0">
                        <v-col class="pt-0 mt-0">
                            <span class="pt-0 mt-0" style="font-size: 12px;">Upload it once completed by clicking on the code of practice declaration field above and clicking save.</span>
                        </v-col>
                    </v-row>
                </template>
                <v-row>
                    <v-col :cols="6">
                        <v-card>
                            <v-card-title>
                                Certificates
                            </v-card-title>
                            <v-card-text>
                                <member-certificates-table />
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import securityService from '../services/securityService'
    import enumService from '../services/enumService'
    import operationEnum from '../enums/operation'
    import errorUtility from '../services/errorUtility'

    export default {
        props: [
            'showExpand'
        ],
        components: {
            contactFields: () => import('../components/ContactFields'),
            memberCertificatesTable: () => import('../tables/MemberCertificatesTable'),
            fileUpload: () => import('../components/FileUpload')
        },
        data() {
            return {
                item: null,
                isLoading: true,
                isSaving: false,
                formKey: 0,
                contactRules: { name: v => !!v || 'Name is required', emailAddress: v => !!v || 'Email is required' },
                operations: enumService.enumAsSelectList(operationEnum),
                operationRules: [v => (v !== null && v !== '') || 'Member Operation is required'], isRequired: true
            }
        },
        mounted() {
            this.load()
        },
        methods: {
            async load() {
                var memberId = securityService.getMemberId();
                var response = await axios.get('/api/Members/' + memberId);
                this.item = response.data;
                this.formKey++;
                this.isLoading = false;
            },
            async save() {
                if (this.isSaving) { return; }
                if (!this.$refs.editForm.validate()) { return; }
                this.isSaving = true;
                var item = Object.assign({}, this.item);
                this.removeEmptyStringOrObjectsFromArray(item);

                try {
                    var response = await axios.put('/api/Members/', item);

                    this.item = response.data;
                } catch (error) {
                    this.$emit('open');
                    errorUtility.handleServerError(error);
                }
                finally {
                    this.isSaving = false;
                    await this.load();
                }
            }
        },
        computed: {
            operationsContainHoneyPacker() {
                if (this.item === null || typeof this.item === "undefined") {
                    return false;
                }
                return this.item.operations.some(e => e == "HoneyPacker");
            }
        }
    };
</script>
<style>
    .profile-title {
        font-size: 150%;
    }
</style>
